import { SET_TOPBAR_COURSE_NAVIGATION_SEARCH_STRING } from './actions';

import './injectReducers';
import { makeMetricsLogEvent } from '../../../ReduxStorage/Metrics/manualEventDispatchers';
import { retrieveLoggedInUserData } from '../../../ReduxStorage/LoggedInUser/dispatchers';
import { currentUserIdSelector } from '../../../ReduxStorage/Auth/selectors';

export const setTopbarCourseNavigationSearchString = (searchString) => (
  dispatch
) =>
  dispatch({
    type: SET_TOPBAR_COURSE_NAVIGATION_SEARCH_STRING,
    searchString,
  });

export const makeTopbarSearchSubmit = (searchString) => (dispatch) => {
  dispatch(
    makeMetricsLogEvent('Course-Searched', {
      action: 'top-bar',
      'search-string': searchString,
    })
  );
};

// This is the same as the src/ReduxStorage/routeThunk/common/loadCurrentUserFromAuth.jsx
export const loadCurrentUser = () => (dispatch, getState) => {
  const userId = currentUserIdSelector(getState());
  if (userId !== null) {
    dispatch(
      retrieveLoggedInUserData({
        userId,
      })
    );
  }
};
